/* eslint-disable new-cap */
/* eslint no-console: ["error", { allow: ["warn", "error", "info"] }] */
/* eslint no-invalid-this: 0 */
/* eslint max-len: 0 */

import {loadVideoBlock} from './loadWg/videoBlock';
import {loadHubHero} from './loadWg/hubHero';
import {loadSiteHeader} from './loadWg/siteHeader';
import {loadSiteHeaderWoolLab} from './loadWg/siteHeaderWoolLab';
import {loadHubGrid} from './loadWg/hubGrid';
import {loadGalleryCarousel} from './loadWg/galleryCarousel';
import {loadCareSlider} from './loadWg/careSlider';
import {loadPageFilter} from './loadWg/pageFilter';
import {loadTextFeature} from './loadWg/textFeature';
import {loadReadingTab} from './loadWg/readingTab';
import {loadProvenceMapSlider} from './loadWg/provenceMapSlider';
import {loadFeatureArticleHero} from './loadWg/featureArticleHero';
import {loadNewsTemplate} from './loadWg/newsTemplate';
import {loadImageSlider} from './loadWg/imageSlider';
import {loadInstagramBlock} from './loadWg/instagramBlock';
import {loadArticleGallery} from './loadWg/articleGallery';
import {loadSocialBar} from './loadWg/socialBar';
import {loadEventTemplate} from './loadWg/eventTemplate';
import {loadMagnifyingGallery} from './loadWg/magnifyingGallery';
import {loadNavigator} from './loadWg/navigator';
import {loadContactUsSearchBlock} from './loadWg/contactUsSearchBlock';
import {loadRenewalForm} from './loadWg/renewalForm';
import {loadSiteFooter} from './loadWg/siteFooter';
import {loadSiteFooterWoolLab} from './loadWg/siteFooterWoolLab';
import {loadSiteFooterSitemap} from './loadWg/siteFooterSitemap';
import {loadChatbotButton} from './loadWg/chatbotButton';
import {loadChatbotBlock} from './loadWg/chatbotBlock';
import {loadTimelineCarousel} from './loadWg/timelineCarousel';
import {loadTabContainer} from './loadWg/tabContainer';
import {loadCollageImageGridItemBlock} from './loadWg/collageImageGridItemBlock';
import {loadShopFeaturedGridItemBlock} from './loadWg/shopFeaturedGridItemBlock';
import {loadShopListingProductBlock} from './loadWg/shopListingProductBlock';
import {loadShopProductBlock} from './loadWg/shopProductBlock';
import {loadShopListingByCategoryBlock} from './loadWg/shopListingByCategoryBlock';
import {loadShopListingBlock} from './loadWg/shopListingBlock';
import {loadShopVideoBlock} from './loadWg/shopVideoBlock';
import {loadProfileListingBlock} from './loadWg/profileListingBlock';
import {loadProfileListingItemBlock} from './loadWg/profileListingItemBlock';
import {loadSupplierListingBlock} from './loadWg/supplierListingBlock';
import {loadSupplierListingItemBlock} from './loadWg/supplierListingItemBlock';
import {loadSourcingGuideBlock} from './loadWg/sourcingGuideBlock';
import {loadSourcingGuideItemBlock} from './loadWg/sourcingGuideItemBlock';
import {loadProfileDetailBlock} from './loadWg/profileDetailBlock';
import {loadVideoListingBlock} from './loadWg/videoListingBlock';
import {loadTabbedPartnerContainerBlock} from './loadWg/tabbedPartnerContainerBlock';
import {loadAboutCompetitionBlock} from './loadWg/aboutCompetitionBlock';
import {loadCardsContainerBlock} from './loadWg/cardsContainerBlock';
import {loadCountdownTimerBlock} from './loadWg/countdownTimerBlock';
import {loadDownloadBriefBlock} from './loadWg/downloadBriefBlock';
import {loadJudgesContainerBlock} from './loadWg/judgesContainerBlock';
import {loadStepByStepItemBlock} from './loadWg/stepByStepItemBlock';
import {loadStepByStepContainerBlock} from './loadWg/stepByStepContainerBlock';
import {loadUpcomingEventsContainerBlock} from './loadWg/upcomingEventsContainerBlock';
import {loadArticleList} from './loadWg/articleList';
import {loadShopItemsWidget} from './loadWg/shopItemsWidget';
import {loadShopItemsCarouselWidget} from './loadWg/shopItemsCarouselWidget';
import {loadProductItemCarouselWidget} from './loadWg/productItemCarouselWidget';
import {loadEcommerceBlock} from './loadWg/ecommerceBlock';
import {loadBioListItem} from './loadWg/bioListItem';
import {loadBioListBlock} from './loadWg/bioListBlock';
import {loadJudgeItemBlock} from './loadWg/judgeItemBlock';
import {loadFeatureBlock} from './loadWg/featureBlock';
import {loadIwpApplicationForm} from './loadWg/iwpApplicationForm';
import {loadHotspotBlock} from './loadWg/hotspotBlock';
import {loadCareculator} from './loadWg/careculator';
import {loadHorizontalScrollBlock} from './loadWg/horizontalScrollBlock';
import {loadGridContainerBlock} from './loadWg/gridContainerBlock';
import {loadWelcomeBannerModal} from './loadWg/welcomeBannerModal';
import {loadHorizontalGalleryBlock} from './loadWg/horizontalGalleryBlock';
import {loadHorizontalYoutubeGalleryBlock} from './loadWg/horizontalYoutubeGalleryBlock';
import {loadParallaxFullWidthBlock} from './loadWg/parallaxFullWidthBlock';
import {loadNewsroomBlock} from './loadWg/newsroomBlock';
import {loadWoolLabSwatchBlock} from './loadWg/woolLabSwatchBlock';
import {loadWoolLabImageBlock} from './loadWg/woolLabImageBlock';
import {loadWoolLabThemesBlock} from './loadWg/woolLabThemesBlock';
import {loadWoolLabSwatchDetailModalBlock} from './loadWg/woolLabSwatchDetailModalBlock';
import {loadWoolLabPersistentSwatchDrawer} from './loadWg/woolLabPersistentSwatchDrawer';
import {loadQuoteBlock} from './loadWg/quoteBlock';

import utils from './utils';
import 'slick-carousel';
import {initVideoPlayer} from './videoPlayer';
import {initFocalPoint} from './focalPoint';
import {initFormElements} from './formElements';

// import pages
import './page';
import {loadWoolLabSwatchLibrarySearchBlock} from './loadWg/woolLabSwatchLibrarySearchBlock';
import {loadWoolLabMyMoodboardsBlock} from './loadWg/woolLabMyMoodboardsBlock';
import {loadWoolLabMySwatchesBlock} from './loadWg/woolLabMySwatchesBlock';
import {loadWoolLabInteractiveMoodboardBlock} from './loadWg/woolLabInteractiveMoodboardBlock';
import {loadWoolLabOnboardingBlock} from './loadWg/woolLabOnboardingBlock';
import {loadMyAccountUpdateProfilePage} from './loadWg/myAccountUpdateProfilePage';
import 'bootstrap/js/dist/modal'; 
import 'bootstrap-select';

let NS = 'woolmark';


window[NS] = {};
window[NS].utils = utils;


$(document).ready(function() {
	if (utils.isIE10OrLess()) {
		$('body').addClass('is-oldBrowser');

		// hides the banner after first scroll
		setTimeout(function() {
			$(window).one('scroll', function() {
				$('.u-oldBrowser').hide();
			});
		}, 2000);
	}

	if (utils.isIPhone()) {
		$('body').addClass('is-iPhone');
	}

	if (utils.isIPad()) {
		$('body').addClass('is-iPad');
	}

	// YouTube Player API
	(function(window) {
		let tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/player_api';
		let firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		// youTubeElements: initiate video players
		// youTubePlayers: control videos in application
		let youTubeElements = document.getElementsByClassName('youtube-player');
		let youTubePlayers = [];

		function onYouTubePlayerAPIReady() {
			// Initiate all YouTube videos which have `youtube-player` class
			const YT = window.YT;
			for (let i = 0; i < youTubeElements.length; ++i) {
				youTubePlayers[i] = new YT.Player(youTubeElements[i], {
					videoId: youTubeElements[i].getAttribute('data-video-id'),
					events: {
						onReady: function() {
							let event = document.createEvent('Event');
							event.initEvent('youtubeVideoReady', true, true);
							document.dispatchEvent(event);
						},
						onStateChange: function() {},
					},
					playerVars: {
						autohide: 1,
						autoplay: youTubeElements[i].getAttribute('data-video-autoplay') || 0,
						cc_load_policy: 0,
						controls: 0,
						disablekb: 0,
						iv_load_policy: 3,
						fs: 1,
						loop: youTubeElements[i].getAttribute('data-video-loop') || 0,
						modestbranding: 1,
						origin: youTubeElements[i].getAttribute('data-video-origin'),
						widget_referrer: youTubeElements[i].getAttribute('data-video-origin'),
						playlist: youTubeElements[i].getAttribute('data-video-loop') === '1' ? youTubeElements[i].getAttribute('data-video-id') : '',
						rel: 0,
						showinfo: 0,
					},
				});
				youTubeElements[i].setAttribute('data-array-index', i);
			}
		}
		// attach variables to the window object to be called on the global scope
		window.youTubePlayers = youTubePlayers;
		window.onYouTubePlayerAPIReady = onYouTubePlayerAPIReady;
	})(window);

	function isOnMobile() {
		return window.innerWidth < 992;
	}


	// Begin click event handler for down button to jump to main content.
	$('.jumpToMainContent').click((e) => {
		// let This = $(this);
		// let $header = $('.siteHeader');
		$('html, body').animate({
			// scrollTop: $('#mainContent').offset().top - $('.siteHeader').outerHeight(),
			// pages other than home won't work after moving the heros within the main!
			// scrollTop: checkOffsetJumpSpace() - (isOnMobile() || !$header.hasClass('is-minified') ? $header.outerHeight() : 0),
			scrollTop: checkOffsetJumpSpace(),
			// scrollTop: ($('.homeHero').length > 0) ? $('#mainContent').offset().top : $('.hubHero').outerHeight(),
		}, 500);
		let firstSec = $('#mainContent').find('.sec--fadeIn').first();
		if (parseInt(firstSec.css('opacity')) === 0) {
			firstSec.animate({'opacity': '1'}, 1500);
		}
	});

	function checkOffsetJumpSpace() {
		if ($('.homeHero').length > 0) {
			return $('#mainContent').offset().top;
		} else if ($('.hubHero').length > 0) {
			return $('.hubHero').outerHeight();
		} else if ($('.featureArticleHero').length > 0) {
			return $('.featureArticleHero').outerHeight();
		} else if ($('.woolLabHeroBlock').length > 0) {
			return $('.woolLabHeroBlock').outerHeight();
		} else if ($('.woolLabThemeHeroBlock').length > 0) {
			return $('.woolLabThemeHeroBlock').outerHeight();
		}
	}

  // Handle back to top button click to scroll to top.
	$('.backToTop').on('click', (e) => {
		// console.log("back to top", e)
		$('html, body').animate({
			scrollTop: 0, // body will scroll to the beginning of the body. all we need is to scroll to the top of the window (0)
		}, 1250);
	});

	// fade animation helper function to check if an element is in the view port
	function isElementOutViewport(el) {
		let rect = el[0].getBoundingClientRect();
		return rect.bottom < 0 || rect.right < 0 || rect.left > window.innerWidth || rect.top > window.innerHeight;
	}

	// hubstack items position init
	$('.hubStack').each(function() {
		const item = $(this);
		let animationOffset = 30;
		// if (!item.parent().hasClass('hideOverFlow')) {
		// 	item.parent().addClass('hideOverFlow');
		// }
		let stackImage = item.find('.hubStack-divImage');
		let divContent = item.find('.hubStack-divContent');
		if (!item.hasClass('hubStack--flipped')) {
			stackImage.css('left', -animationOffset + 'px');
			divContent.css('right', -animationOffset + 'px');
		} else {
			stackImage.css('right', -animationOffset + 'px');
			divContent.css('left', -animationOffset + 'px');
		}
	});

	// check number of image within "articleImage--dual" class
	$('.articleImage--dual').each(function(i, item) {
		if ($(item).find('img').length === 1) {
			$(item).addClass('articleImage--single');
		}
	});

	// articleGrid items position init
	$('.articleGridItem').each(function() {
		const item = $(this);
		let animationOffset = 30;
		// if (!item.parent().hasClass('hideOverFlow')) {
		// 	item.parent().addClass('hideOverFlow');
		// }
		if (!item.hasClass('sec--fadeIn')) {
			item.addClass('sec--fadeIn');
		}
		let articleGridItemText = item.find('.articleGridItem-text');
		let articleGridItemImages = item.find('.articleGridItem-images');
		if (!item.hasClass('articleGridItem--flipped')) {
			articleGridItemText.css('left', -animationOffset + 'px');
			articleGridItemImages.css('right', -animationOffset + 'px');
		} else {
			articleGridItemText.css('right', -animationOffset + 'px');
			articleGridItemImages.css('left', -animationOffset + 'px');
		}
	});

	const heroVideoScrollCB = heroVideoScrollConditions();

	window.onscroll = (e) => {
		heroVideoScrollCB();

		// sections animations
		$('.sec--fadeIn').each( function() {
			const $sec = $(this);
			// If sec is completely visible in the viewport, fade it in
			if ( !isElementOutViewport($sec) ) {
				if (parseInt($sec.css('opacity')) === 0) {
					$sec.animate({'opacity': '1'}, 1500);
				}
				// if a hubstack
				if ($sec.hasClass('hubStack')) {
					let stackImage = $sec.find('.hubStack-divImage');
					let divContent = $sec.find('.hubStack-divContent');
					stackImage.animate({'left': '', 'right': ''}, 1000);
					divContent.animate({'left': '', 'right': ''}, 1000);
				}
				// if an articleGrid
				if ($sec.hasClass('articleGridItem')) {
					let articleGridItemText = $sec.find('.articleGridItem-text');
					let articleGridItemImages = $sec.find('.articleGridItem-images');
					articleGridItemText.animate({'left': '', 'right': ''}, 1000);
					articleGridItemImages.animate({'left': '', 'right': ''}, 1000);
				}
			}
		});

		// sections animations
		$('.sec--animate').each( function() {
			const $sec = $(this);
			if ( !isElementOutViewport($sec) ) {
				$sec.addClass('active');
			}
		});
	};

	// sections animations - check on initial load
	$('.sec--animate').each( function() {
		const $sec = $(this);
		if ( !isElementOutViewport($sec) ) {
			$sec.addClass('active');
		}
	});
	// End fade animation

	// adjust bigText margin if there is no social sharing icons
	if ($('.featureArticleHero').length > 0) {
		$('.textFeature').first().addClass('textFeature--isFirst');
	}

	// if a select is changed on submissionForm / request innovation
	// wpc only
	$(document).on('change', '.wpcRequestInnovationKitPage select, .wpcSubmissionFormPage select', function() {
		specialSelectsStyles();
	});
	// do that on load as well
	specialSelectsStyles();

	// Load SiteHeader widget
	loadSiteHeader(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load loadSiteHeaderWoolLab widget
	loadSiteHeaderWoolLab(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load HubGrid widget
	loadHubGrid(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load GalleryCarousel widget
	loadGalleryCarousel(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

    // Load videoBlock widget
    loadVideoBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// Load HubHero widget
	loadHubHero(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load CareSlider widget
	loadCareSlider(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load MagnifyingGallery widget
	loadMagnifyingGallery(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// Load PageFilter widget
	loadPageFilter(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load textFeature widget
	loadTextFeature(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length > 0) ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// Load ReadingTab widget
	loadReadingTab(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load ProvenceMapSlider widget
	loadProvenceMapSlider(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load FeatureArticleHero widget
	loadFeatureArticleHero(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load ImageSlider widget
	loadImageSlider(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load ArticleGallery widget
	loadArticleGallery(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// Load Navigator widget
	loadNavigator(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load NewsTemplate widget
	loadNewsTemplate(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load SocialBar widget
	loadSocialBar(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// Load EventTemplate widget
	loadEventTemplate(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);


	// Load ContactUsSearchBlock widget
	loadContactUsSearchBlock(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load RenewalForm widget
	loadRenewalForm(document.body).then((wg) => {
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load SiteFooter widget
	loadSiteFooter(document.body).then((wg) => {
		// console.log(NS, "loadSiteFooter", wg.init);
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load SiteFooterWoolLab widget
	loadSiteFooterWoolLab(document.body).then((wg) => {
		// console.log(NS, "SiteFooterWoolLab", wg.init);
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load SiteFooter widgest
	loadSiteFooterSitemap(document.body).then((wg) => {
		// console.log(NS, "loadSiteFooterSitemap", wg.init);
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load ChatbotButton widget
	loadChatbotButton(document.body).then((wg) => {
		// console.log(NS, "loadChatbotButton", wg.init);
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load TimelineCarousel widget
	loadTimelineCarousel(document.body).then((wg) => {
		// console.log(NS, "loadChatbotButton", wg.init);
		wg ? wg.init() : '';
	}).catch((err) => err);

	// Load ChatbotBlock widget
	loadChatbotBlock(document.body).then((wg) => {
		// console.log(NS, "loadChatbotBlock", wg.init);
		wg ? wg.init() : '';
	}).catch((err) => err);

	// loadTabContainer Widget
	loadTabContainer(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadCollageImageGridItemBlock
	loadCollageImageGridItemBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadShopFeaturedGridItemBlock
	loadShopFeaturedGridItemBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadShopProductBlock
	loadShopProductBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadShopListingBlock
	loadShopListingBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadShopListingByCategoryBlock
	loadShopListingByCategoryBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadShopListingProductBlock
	loadShopListingProductBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);
	
	// loadShopVideoProductBlock
	loadShopVideoBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadProfileListingBlock
	loadProfileListingBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadProfileListingItemBlock
	loadProfileListingItemBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadSupplierListingBlock
	loadSupplierListingBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadSupplierListingItemBlock
	loadSupplierListingItemBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadSourcingGuideBlock
	loadSourcingGuideBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadSourcingGuideItemBlock
	loadSourcingGuideItemBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadProfileDetailBlock
	loadProfileDetailBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadVideoListingBlock
	loadVideoListingBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// TabbedPartnerContainerBlock
	loadTabbedPartnerContainerBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadAboutCompetitionBlock
	loadAboutCompetitionBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadCardsContainerBlock
	loadCardsContainerBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// CountdownTimerBlock
	loadCountdownTimerBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// DownloadBriefBlock
	loadDownloadBriefBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// judgesContainerBlock
	loadJudgesContainerBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// StepByStepItemBlock
	loadStepByStepItemBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// StepByStepContainerBlock
	loadStepByStepContainerBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadUpcomingEventsContainerBlock
	loadUpcomingEventsContainerBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadarticleList
	loadArticleList(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadShopItemsWidget
	loadShopItemsWidget(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadShopItemsCarouselWidget
	loadShopItemsCarouselWidget(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadProductItemCarouselWidget
	loadProductItemCarouselWidget(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadEcommerceBlock
	loadEcommerceBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadBioListItem
	loadBioListItem(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadBioListBlock
	loadBioListBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadJudgeItemBlock
	loadJudgeItemBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadFeatureBlock
	loadFeatureBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadIwpApplicationForm
	loadIwpApplicationForm(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadHotspotBlock
	loadHotspotBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadCareculator
	loadCareculator(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadHorizontalScrollBlock
	loadHorizontalScrollBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadGridContainerBlock
	loadGridContainerBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWelcomeBannerModal
	loadWelcomeBannerModal(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadHorizontalGalleryBlock
	loadHorizontalGalleryBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadHorizontalYoutubeGalleryBlock
	loadHorizontalYoutubeGalleryBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadParallaxFullWidthBlock
	loadParallaxFullWidthBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadNewsroomBlock
	loadNewsroomBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabSwatchBlock
	loadWoolLabSwatchBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabImageBlock
	loadWoolLabImageBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadinstagramBlock
	loadInstagramBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);
	
	// loadWoolLabThemesBlock
	loadWoolLabThemesBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabSwatchDetailModalBlock
	loadWoolLabSwatchDetailModalBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabSwatchLibrarySearchBlock
	loadWoolLabSwatchLibrarySearchBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabMyMoodboardsBlock
	loadWoolLabMyMoodboardsBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabMySwatchesBlock
	loadWoolLabMySwatchesBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabInteractiveMoodboardBlock
	loadWoolLabInteractiveMoodboardBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// loadWoolLabOnboardingBlock
	loadWoolLabOnboardingBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// WoolLabPersistentSwatchDrawer
	loadWoolLabPersistentSwatchDrawer(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// MyAccountUpdateProfilePage
	loadMyAccountUpdateProfilePage(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// Load quote block
	loadQuoteBlock(document.body, true).then((wgAll) => {
		(wgAll && wgAll.length) > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((err) => err);

	// change mobile-desktop image on resize
	function switchMbDtIMage(el, imgMb, imgDt) {
		if (isOnMobile()) {
			if (imgMb) {
				el.style.backgroundImage = `url('${imgMb}')`;
			}
			else if (imgDt) {
				el.style.backgroundImage = `url('${imgDt}')`;
			}
			else {
				el.style.backgroundColor = "#000";
			}
		} 
		else {
			if (imgDt) {
				el.style.backgroundImage = `url('${imgDt}')`;
			}
			else {
				el.style.backgroundColor = "#000";
			}
		}
	}

	/**
	 * Pauses the home page video when not in view. IE & Edge really needed this because performance was terrible.
	 * Also includes an Edge hack 'force 3d' when hero video element is playing to show the nav above the video when scrolling.
	 * @return - function to be called on scroll event
	 */
	function heroVideoScrollConditions() {
		const $homePageWrap = document.querySelector('.main.homePage');
		const $mainContent = document.querySelector('#mainContent');
		const $heroVideo = document.querySelector('video.homeHero-video') || document.querySelector('video.hubHero-video');
		const heroVideoIsVis = $heroVideo ? window.getComputedStyle($heroVideo).display !== 'none' : null; // mobile gets ignored because not visible
		const $siteHeader = document.querySelector('.siteHeader');
		const $nextSection = $mainContent && $heroVideo ? $($heroVideo).closest('section').next('section') : null;
		const isEdge = utils.isMSEdge();
		let to;

		return function() {
			// Pauses the home page video when not in view. IE & Edge really needed this because performance was terrible.
			if (heroVideoIsVis && $mainContent && $heroVideo ) {
				/**
				 * Hiding the video when paused and not visible helps stop the video showing in the bg when scrolling, mainly in IE & Edge
				 */
				if ($homePageWrap) {
					if (window.pageYOffset > $mainContent.offsetTop) {
						$heroVideo.classList.add('no-vis');
					} else {
						$heroVideo.classList.remove('no-vis');
					}
				} else {
					// if hub page
					// console.log(window.pageYOffset, $heroVideo.offsetHeight)
					if (window.pageYOffset > $heroVideo.offsetHeight) $heroVideo.pause();
					else $heroVideo.play();
				}

				$heroVideo.pause();

				/**
				 * The timeout was put in place to pause the video when scrolling for 700ms, just to
				 * help with performance.
				 */
				if (to) clearTimeout(to);
				to = setTimeout(() => {
					clearTimeout(to);

					// if home page
					if ($homePageWrap) {
						if (window.pageYOffset > $mainContent.offsetTop) {
							$heroVideo.pause();
						} else {
							$heroVideo.play();
						}
					} else {
						// if hub page
						// console.log(window.pageYOffset, $heroVideo.offsetHeight)
						if (window.pageYOffset > $heroVideo.offsetHeight) $heroVideo.pause();
						else $heroVideo.play();
					}

					if (isEdge && window.pageYOffset > 0) {
						if ($siteHeader) $siteHeader.classList.remove('is-forced3d');
						if ($nextSection && $nextSection.length) $nextSection.removeClass('is-forced3d');
					}
				}, 700);
			} // end if


			// forcing a 1px transform forces Edge to render the element as 3d, which fixed visibility issues with video until scroll has stopped
			if (isEdge) {
				if ($siteHeader) $siteHeader.classList.add('is-forced3d');
				if ($nextSection && $nextSection.length) $nextSection.addClass('is-forced3d');
			}
		};
	} // end heroVideoScrollConditions


	// homeHero scripts
	const homeHero = document.querySelector('.homeHero');
	if (homeHero) {
		// check if there is a next sibling
		if (homeHero.nextElementSibling) {
			homeHero.nextElementSibling.style.marginTop = homeHero.clientHeight + 'px';
		}

		let imgMb = homeHero.getAttribute('data-mb-image');
		let imgDt = homeHero.style.backgroundImage;

		if (imgMb && imgMb != '') {
			switchMbDtIMage(homeHero, imgMb, imgDt);
		}

		$(window).on('resize', function() {
			// check if there is a next sibling
			if (homeHero.nextElementSibling) {
				homeHero.nextElementSibling.style.marginTop = homeHero.clientHeight + 'px';
			}

			if (imgMb && imgMb != '') {
				switchMbDtIMage(homeHero, imgMb, imgDt);
			}
		});
	}

	// hubHero scripts
	const hubHero = document.querySelector('.hubHero');
	if (hubHero) {
		let imgMb = hubHero.getAttribute('data-mb-image');
		let imgDt = hubHero.getAttribute('data-dt-image');

		switchMbDtIMage(hubHero, imgMb, imgDt);

		$(window).on('resize', function() {
			switchMbDtIMage(hubHero, imgMb, imgDt);
		});
	}

	// shopHero scripts
	const shopHero = document.querySelector('.shopHero');
	if (shopHero) {
		let imgMb = shopHero.getAttribute('data-mb-image');
		let imgDt = shopHero.getAttribute('data-dt-image');

		switchMbDtIMage(shopHero, imgMb, imgDt);

		$(window).on('resize', function() {
			switchMbDtIMage(shopHero, imgMb, imgDt);
		});
	}

	if (utils.isIE11OrLess()) {
		document.body.classList.add('is-ie11OrLess');
	}


	/**
	 * Adds the 'is-titlesReady' class to the body, with a customisable delay.
	 * This is done so there is a small delay on titles showing to avoid seeing a flicker of font style change as the fonts load from typekit.
	 * Affects elements with the 'u-titleFadeIn' class.
	 */
	let $titleDelayEl = $('[data-title-delay]');
	let titleDelay = $titleDelayEl.length ? $titleDelayEl.attr('data-title-delay') : '0';
	titleDelay = parseInt(titleDelay, 10);
	setTimeout(() => {
		$('body').addClass('is-titlesReady');
	}, titleDelay);

	// init video player
	initVideoPlayer();

	// init focalpoints for all images
	initFocalPoint();

	// init form elements
	initFormElements();

	function specialSelectsStyles() {
		$(document).find('.wpcRequestInnovationKitPage select, .wpcSubmissionFormPage select').each(function() {
			let value = $(this).val();
			if (value && value != '') {
				$(this).addClass('is-selected-epiform');
			} else {
				$(this).removeClass('is-selected-epiform');
			}
		});
	}

	utils.checkTheme();

	// bio page affix image
	if ($(document).find('.bioPage.is-standalone').length > 0) {
		let page = $(document).find('.bioPage.is-standalone');
		let profileImage = page.find('.bioPage-profileImage');
		let offsetTop = (profileImage.offset().top - ($(document).find('header').height() - $(window).scrollTop() || 0)) || 120;

		$(window).resize(() => {
			affixImg(profileImage, offsetTop);
		});

		if (!utils.isSmallerThanTablet()) {
			$(window).on('scroll', function() {
				profileImage.trigger('sticky_kit:recalc');
			});
		}

		setTimeout(() => {
			affixImg(profileImage, offsetTop);
		}, 500);
	}

	function affixImg(profileImage, offsetTop) {
		if (!utils.isSmallerThanTablet()) {
			profileImage.stick_in_parent({
				offset_top: offsetTop,
			});

			$(window).trigger('scroll');
		}
	}

	// add is-restructured
	if (!$('body').hasClass('is-wpc') && !$('body').hasClass('is-iwp')) {
		$('body').addClass('is-restructured');
	}
});
